import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { contribLegge59BaseCalcoloRules } from './contrib-legge-59-base-calcolo.rules';
import { contribLegge59VersamentiRules } from './contrib-legge-59-versamenti.rules';
import { contribLegge59VIrregolaritaRules } from './contrib-legge-59-irregolarita.rules';

export const contribLegge5992Rules: FormGroupRules = {
    ...contribLegge59BaseCalcoloRules,
    ...contribLegge59VersamentiRules,
    ...contribLegge59VIrregolaritaRules,
};

export const contribLegge5992FormValidators = Object.values(contribLegge5992Rules);
